import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

export const TimerBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.625rem;
  border-radius: ${({ theme }) => theme.radii.md};
  background: ${({ theme }) => theme.colors.danger}15;
  color: ${({ theme }) => theme.colors.danger};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  font-variant-numeric: tabular-nums;
`;

export const TimerDot = styled.span`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.danger};
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[2]};
  flex-wrap: wrap;
`;

export const DurationDisplay = styled.span`
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

/* Wrapper that tints the running-timer row in a DataTable.
   The DataTable applies a class via the rowClassName prop. */
export const TimerTableWrap = styled.div`
  tr.is-timer-row {
    background: ${({ theme }) => theme.colors.danger}08;
  }
`;
